import {fetchHolidays} from '@/api/schedulerApi.js'
import moment from 'moment'

export const eventMixin = {
  data () {
    return {
      events: [],
      id: null,
      groupId: null,
      allDay: null,
      start: null,
      end: null,
      title: null,
      url: null,
      color: null,
      backgroundColor: null,
      borderColor: null,
      textColor: null,
      eventGuid:0,
      teacherList:[],
      studentList:[]
    }
  },
  methods: {
    createEventId () {
      return String(this.eventGuid++)
    },
    setEvent () {
      this.events.push({
        id: null,
        groupId: null,
        allDay: true,
        start: null,
        end: null,
        title: null,
        url: null,
        color: null,
        backgroundColor: null,
        borderColor: null,
        textColor: null
      })
    },
    removeNewEvent () {
      const calendarApi = this.$refs.fullCalendar.getApi()
      const event = calendarApi.getEventById(4)
      event.remove()
    },
    schedulingListHoliday (events) {
      return events.map(ele => {
        
        return {
          id : ele.id,
          start : `${ele.start_hour.substr(0, 10)}`,
          end : `${ele.end_hour.substr(0, 10)}`,
          backgroundColor : 'red',
          description:ele.description,
          allDay:true


        }
      })
    }, 
    creatingPayload (type) {
      
      const year = this.calendarApi.getDate().getFullYear()
      const month = this.calendarApi.getDate().getMonth() + 1  //jan = 0
      const monthString = String(month).padStart(2, 0)  // 0009  
      return {
        // user_id: [],
        type,
        year,
        month: monthString
        // type:'teacher'
      }
    },
    nextMonth (type) {
      
      this.calendarApi.next()
      const payload = this.creatingPayload(type)
      this.fetchingEvent(payload, type)
    },
    previousMonth (type) {
      this.calendarApi.prev()
      const payload = this.creatingPayload(type)
      this.fetchingEvent(payload, type)
      
    },
    today (type) {
      
      this.calendarApi.today()
      const payload = this.creatingPayload(type)
      this.fetchingEvent(payload, type)
    },
    async fetchingEvent (payloadData = null, type) {

      try {
        this.$vs.loading({
          text:'Fetching Events'
        })
        const customer_id = this.$store.getters.customerId
        let payload = {}
        if (!payloadData) {
  
          const newDate = new Date()
          const year = newDate.getFullYear()
          const month = newDate.getMonth() + 1  //jan = 0
          const monthString = String(month).padStart(2, 0)  // 0009      
          
          
          payload = {
            // user_id: 1,
            type,
            year,
            month: monthString
            // type:'teacher'
  
          }
        } else {
          payload = payloadData
        }
        const user_id = JSON.parse(localStorage.getItem('userInfo')).id
        const responseList = await fetchHolidays(user_id, customer_id, payload)
        
        this.schedulingList = responseList.data.data.holiday
        
        
        let scheduleArray = []
        
        scheduleArray = this.schedulingListHoliday(this.schedulingList)
  
        
        this.eachMonthEventData = scheduleArray
        // this.schedulingList = scheduleArray
        
        
        this.calendarOptions.events = scheduleArray
  
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    getContrast (hexcolor) {
      //   // 
      hexcolor = hexcolor.replace('#', '')
      const r = parseInt(hexcolor.substr(0, 2), 16)
      const g = parseInt(hexcolor.substr(2, 2), 16)
      const b = parseInt(hexcolor.substr(4, 2), 16)
      const yiq = (r * 299 + g * 587 + b * 114) / 1000
      return yiq >= 128 ? '#000000' : '#ffffff'
    },
    validateTodayDate (todayDate, selectedDateParameter) {
      const today = moment(todayDate)
      const selectedDate = moment(selectedDateParameter)
      const differenceDate = today.diff(selectedDate, 'days')
      return differenceDate
    }
  }
 
}

// ReadMe->for All Datatype for Calendar
// id
// String or Integer. Will uniquely identify your event. Useful for getEventById.

// groupId
// String or Integer. Events that share a groupId will be dragged and resized together automatically.

// allDay
// Boolean (true or false). Determines if the event is shown in the “all-day” section of the view, if applicable. Determines if time text is displayed in the event. If this value is not specified, it will be inferred by the start and end properties. See notes below.

// Do not put quotes around this value. That would make it a string, not a boolean.

// start
// Something date-parseable. When your event begins. If your event is explicitly allDay, hour, minutes, seconds and milliseconds will be ignored.

// end
// Something date-parseable. When your event ends. If your event is explicitly allDay, hour, minutes, seconds and milliseconds will be ignored. If omitted, your events will appear to have the default duration. See defaultAllDayEventDuration, defaultTimedEventDuration, and forceEventDuration for more info.

// Note: This value is exclusive. For example, if you have an all-day event that has an end of 2018-09-03, then it will span through 2018-09-02 and end before the start of 2018-09-03.

// daysOfWeek
// Array. (For defining a simple recurring event). The days of the week this event repeats. An array of integers representing days e.g. [0, 1] for an event that repeats on Sundays and Mondays.

// startTime
// Something duration-parseable. (For defining a simple recurring event). The time of day the event starts.

// endTime
// Something duration-parseable. (For defining a simple recurring event). The time of day the event ends.

// startRecur
// Something date-parseable. (For defining a simple recurring event). When recurrences of the event start.

// endRecur
// Something date-parseable. (For defining a simple recurring event). When recurrences of the event end.

// title
// String. The text that will appear on an event.

// url
// String. A URL that will be visited when this event is clicked by the user. For more information on controlling this behavior, see the eventClick callback.

// className or
// classNames
// String or Array. A single string like 'myclass', a space-separated string like 'myclass1 myclass2', or an array of strings like [ 'myclass1', myclass2' ]. Determines which HTML classNames will be attached to the rendered event.

// editable
// Boolean (true or false). Overrides the master editable option for this single event.

// startEditable
// Boolean (true or false). Overrides the master eventStartEditable option for this single event.

// durationEditable
// Boolean (true or false). Overrides the master eventDurationEditable option for this single event.

// resourceEditable
// Boolean (true or false). Overrides the master eventResourceEditable option for this single event. Requires one of the resource plugins.

// resourceId
// String. The string ID of a Resource. See Associating Events with Resources. Requires one of the resource plugins.

// resourceIds
// Array. An array of string IDs of Resources. See Associating Events with Resources. Requires one of the resource plugins.

// display
// Allows alternate rendering of the event, like background events. Can be 'auto' (the default), 'block', 'list-item', 'background', 'inverse-background', or 'none'. See eventDisplay.

// overlap
// Boolean (true or false). Overrides the master eventOverlap option for this single event. If false, prevents this event from being dragged/resized over other events. Also prevents other events from being dragged/resized over this event.

// constraint
// A groupId belonging to other events, "businessHours", or an object. Overrides the master eventConstraint option for this single event.

// color
// String. An alias for specifying the backgroundColor and borderColor at the same time.

// backgroundColor
// Sets an event’s background color just like the calendar-wide eventBackgroundColor option.

// borderColor
// Sets an event’s border color just like the calendar-wide eventBorderColor option.

// textColor
// Sets an event’s text color just like the calendar-wide eventTextColor option.

// rrule
// duration
// These properties are for RRule recurrence.

// daysOfWeek
// startTime
// endTime
// startRecur
// endRecur
// groupId
// These properties are for “simple” recurrence.

// extendedProps
// Object. A plain object with any miscellaneous properties. It will be directly transferred to the extendedProps hash in each Event Object. Often, these props are useful in event render hooks.

// any other property!
// Every other non-standard property will be transferred over to the extendedProps hash in the Event Object. However, it is recommended to explicitly define these in the extendedProps hash.
